import './lalocanda/style';
import FormStructure from './lalocanda/form_structure';

export default FormStructure;